import { URL_API } from "../../../general/init/url";

export const API_LAPORAN_AKHIR_GET = URL_API + "/api/laporanAkhirData";
export const API_LAPORAN_AKHIR_GENERATE =
  URL_API + "/api/laporanAkhirData/Generate";
export const API_LAPORAN_AKHIR_GET_DOWNLOAD =
  URL_API + "/api/laporanAkhirData/Download";
export const API_LAPORAN_AKHIR_GET_DOWNLOAD_PDF =
  URL_API + "/api/laporanAkhirData/DownloadPDF";
